
import React from 'react';
import './PageHeader.css';

interface Props {
  title: string;
  breadcrumb?: string[];
  actions?: React.ReactNode;
}

export default function PageHeader({ title, breadcrumb, actions }: Props) {
  return (
    <div className="page-header">
      <div className="page-header__left">
        {breadcrumb && (
          <div className="page-header__breadcrumb">
            {breadcrumb.map((b, i) => (
              <span key={i}>
                {i > 0 && <span className="page-header__sep">›</span>}
                <span className={i === breadcrumb.length - 1 ? 'page-header__bc-current' : 'page-header__bc-item'}>{b}</span>
              </span>
            ))}
          </div>
        )}
        <h1 className="page-header__title">{title}</h1>
      </div>
      {actions && <div className="page-header__actions">{actions}</div>}
    </div>
  );
}
